import React from "react";
import { Link } from "react-router-dom";
import { WholesaleQuote } from "@/components/WholesaleQuote";
import { Container, ShieldCheck, Globe2 } from "lucide-react";

export default function Quote() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="quote-page">
      <div className="rounded-2xl sn-ink-bg sn-noise relative overflow-hidden p-7 sm:p-10 text-white mb-8">
        <div className="relative max-w-2xl">
          <nav className="text-xs text-white/50 mb-4"><Link to="/" className="hover:text-emerald">Home</Link> <span className="mx-1">/</span> <span className="text-white/90">Request a Quote</span></nav>
          <div className="h-1.5 w-16 bg-emerald rounded-full mb-4" />
          <h1 className="font-clash uppercase font-bold text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">Wholesale Water Quote</h1>
          <p className="text-white/60 mt-3 text-sm">Enter the cases you need per bottle size — we'll instantly work out pallets, containers and load fill, then send you a full quote.</p>
          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-white/70 text-[11px] font-bold uppercase tracking-[0.15em]">
            <span className="flex items-center gap-1.5"><Container size={13} className="text-emerald" /> 20 pallets / container</span>
            <span className="flex items-center gap-1.5"><Globe2 size={13} className="text-emerald" /> Worldwide export</span>
            <span className="flex items-center gap-1.5"><ShieldCheck size={13} className="text-emerald" /> Trusted supply</span>
          </div>
        </div>
      </div>
      <WholesaleQuote />
    </div>
  );
}
